/*!
 * Copyright (c) 2020 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';
/**
 * Used as an umbrella wrapper around multiple verification errors.
 */

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var VerificationError = /*#__PURE__*/function (_Error) {
  _inherits(VerificationError, _Error);

  /**
   * @param {Error|Error[]} errors
   */
  function VerificationError(errors) {
    var _this;

    _classCallCheck(this, VerificationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VerificationError).call(this, 'Verification error(s).'));
    _this.name = 'VerificationError';
    _this.errors = [].concat(errors);
    return _this;
  }

  return VerificationError;
}(_wrapNativeSuper(Error));

module.exports = VerificationError;